import React, { useState } from "react";

import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { useHistory } from "react-router-dom";

import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validatesNotNull from "../../utils/validatesNotNull";
import { createTypePointAccess } from "../../repositories/typePointAccessRepository";
import TextFieldCustom from "../../components/basic/TextFieldCustom";

const CreateTypesPointAccess = () => {
  const { goBack } = useHistory();
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      const resultValidation = validatesNotNull([
        { value: description, key: "description" },
      ]);

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      }

      const { data } = await createTypePointAccess({
        body: {
          Descricao: description,
        },
      });

      setLoading(false);

      if (data.success) {
        notify("Registro criado com sucesso.", true, "info");
        goBack();
      }
    } catch (error) {
      console.error("ERROR: CreateTypesPointAccess", error);
      return setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={6}
          md={7}
          sm={7}
          xs={10}
          id="formContent"
        >
          <ArrowBackIcon className="iconGoBack" onClick={goBack} />

          <label className="title">Novo tipo de ponto de acesso</label>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Descrição*"
              autoFocus
              type="text"
              value={description}
              setValue={setDescription}
              error={errors.description}
            />
          </Grid>

          <button
            id="buttonStyle"
            type="submit"
            className="btn btn-info btn-block"
          >
            Inserir
          </button>
        </Grid>
      </Grid>
    </form>
  );
};
export default CreateTypesPointAccess;
